import { render, staticRenderFns } from "./DataNotFound.vue?vue&type=template&id=02d57beb&scoped=true"
var script = {}
import style0 from "./DataNotFound.vue?vue&type=style&index=0&id=02d57beb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d57beb",
  null
  
)

export default component.exports